import { useMemo } from 'react';

import {
  createFallbackProvider,
  useAddressAutocomplete as useSharedAddressAutocomplete,
} from '@lender/utils';

import { mapReapiToAddressFields } from '../../addressAutocomplete.utils';

import { getGoogleKey, getReapiKey } from './utils';

export const useAddressAutocompleteAdapter = ({ searchTypes } = {}) => {
  const provider = useMemo(
    () =>
      createFallbackProvider({
        getReapiApiKey: getReapiKey,
        getGoogleApiKey: getGoogleKey,
        searchTypes,
      }),
    [searchTypes],
  );

  const {
    suggestions: rawSuggestions,
    isLoading,
    search,
    clearSuggestions,
  } = useSharedAddressAutocomplete({ provider });

  const suggestions = useMemo(
    () =>
      rawSuggestions.map(suggestion => ({
        raw: suggestion,
        mapped: mapReapiToAddressFields(suggestion),
      })),
    [rawSuggestions],
  );

  return {
    suggestions,
    isLoading,
    search,
    clearSuggestions,
  };
};
